var _g, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMn9VwcitY0Ixzkl(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.6377 12.0235C21.4274 10.3317 20.0191 9.08414 18.3375 9.08414H16.0252C14.3647 9.08414 12.9352 10.353 12.7461 12.0235L12.4309 14.7302C12.3888 15.0897 12.599 15.407 12.9564 15.4915C13.2716 15.5549 13.587 15.6184 13.9234 15.6607L16.3827 13.7998C16.677 13.5882 17.0133 13.4614 17.3916 13.4614C18.1063 13.4614 18.7369 13.9266 18.9891 14.6032L19.3885 15.8086C20.1032 15.7241 20.7969 15.6394 21.4696 15.4915C21.8059 15.407 22.0371 15.0897 21.9951 14.7302L21.6377 12.0235Z",
    fill: "#516F93"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.3134 5.12978C20.3134 6.85823 18.9205 8.25941 17.2023 8.25941C15.4842 8.25941 14.0914 6.85827 14.0914 5.12978C14.0914 3.40133 15.4841 2 17.2023 2C18.9204 2 20.3134 3.40129 20.3134 5.12978Z",
    fill: "#516F93"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.93269 15.1485H5.6204C3.93876 15.1485 2.53046 16.4174 2.32018 18.0878L2.00494 20.7946C1.96286 21.1541 2.19409 21.4713 2.53044 21.5559C3.87572 21.8519 5.28403 22 6.77649 22C8.24786 22 9.6773 21.8519 11.0225 21.5559C11.3589 21.4713 11.5901 21.154 11.548 20.7946L11.2328 18.0878C11.0224 16.3961 9.61418 15.1485 7.93269 15.1485Z",
    fill: "#516F93"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.88748 11.1941C9.88748 12.9226 8.49471 14.3238 6.77655 14.3238C5.05842 14.3238 3.66547 12.9226 3.66547 11.1941C3.66547 9.46565 5.05839 8.06436 6.77655 8.06436C8.49468 8.06436 9.88748 9.46565 9.88748 11.1941Z",
    fill: "#516F93"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.9303 15.2929C17.8463 15.018 17.5099 14.9124 17.2787 15.0814L14.462 17.2173C14.1887 17.4288 14.2518 17.8728 14.5881 17.9785L15.3869 18.2322C14.9454 19.5011 14.1257 20.5161 13.0747 21.2139C12.9486 21.2984 12.9906 21.5311 13.1377 21.5523C15.0925 21.8907 17.0264 20.8121 17.7201 18.9301L18.5399 19.1838C18.8762 19.2896 19.1914 18.9723 19.0654 18.6341L17.9303 15.2929Z",
    fill: "#516F93"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMn9VwcitY0Ixzkl);
export default __webpack_public_path__ + "static/media/mn9vwcit-y0ixzkl.3d6f03a380969a6e9f0e35c0ae70f184.svg";
export { ForwardRef as ReactComponent };